import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useResizeObservedElement } from '../useResizeObservedElement';

/**
 * Returns the size information of the given element.
 * The size will also get observed and will trigger state updates when it changes
 */
export function useElementSize(element) {
  const $ = _c(10);
  let t0;
  if ($[0] !== element) {
    t0 = getElementSize(element);
    $[0] = element;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [size, setSize] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== element) {
    t1 = () => {
      setSize(getElementSize(element));
    };
    t2 = [element];
    $[2] = element;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== element) {
    t3 = () => {
      setSize(getElementSize(element));
    };
    $[5] = element;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== element || $[8] !== t3) {
    t4 = {
      element,
      callback: t3
    };
    $[7] = element;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useResizeObservedElement(t4);
  return size;
}
function getElementSize(element: Element | null): ElementSize | null {
  if (!element) {
    return null;
  }
  return {
    clientHeight: element.clientHeight,
    clientWidth: element.clientWidth
  };
}
export type ElementSize = {
  clientWidth: number;
  clientHeight: number;
};